import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { bigblueIntegrationQuery } from "modules/settings/lib/bigblue/bigblueIntegrationQuery"

export function useDeleteBigBlueIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      await axios.delete("/integrations/bigblue/configuration")
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: bigblueIntegrationQuery().queryKey })
    },
  })
}
